import type { ApiInvoice } from '#/api/invoice/types/ApiInvoice';
import type { ApiInvoiceId, ApiOrgId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  invoice: ApiInvoice;
  org: { id: ApiOrgId; name: string } | undefined;
};

function mapResponse(response: ApiResponse) {
  return response;
}

const endpoint = new FetchEndpoint({
  urlFactory: (invoiceId: ApiInvoiceId) => `/data/invoices/${invoiceId}`,
  mapResponse,
});

// Exports

export const apiIsomorphicFetchInvoice = endpoint.createIsomorphicFetchFn();
